var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.isVisible,
        title: _vm.title,
        "destroy-on-close": true,
        width: "80%",
      },
      on: { close: _vm.hide },
    },
    [
      _vm.hasUrl
        ? _c("send-list-table", { attrs: { url: _vm.url } })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }